var _path, _path2, _path3, _circle, _circle2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuests6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0067FF",
    stroke: "#0067FF",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 0v1m0 7v-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M7 19a2 2 0 1 0-4 0 2 2 0 0 0 4 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 19a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm0 0h1m9-2a2 2 0 1 1-2 2m2-2a2 2 0 0 0-2 2m2-2v-1m-2 3h-1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 13,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 19,
    r: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    d: "m17 13-.647.763-.001-.002-.004-.002-.01-.01-.039-.033-.137-.121a20.909 20.909 0 0 1-1.923-1.967c-.525-.617-1.072-1.343-1.491-2.109C12.335 8.766 12 7.892 12 7c0-1.547.538-2.825 1.49-3.711C14.431 2.413 15.69 2 17 2c1.31 0 2.569.413 3.51 1.289C21.462 4.175 22 5.453 22 7c0 .892-.335 1.766-.748 2.52-.42.765-.965 1.491-1.49 2.108a20.909 20.909 0 0 1-2.061 2.088l-.038.033-.011.01-.004.002v.001h-.001L17 13zm0 0 .646.763a1 1 0 0 1-1.292 0L17 13zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuests6);
export default __webpack_public_path__ + "static/media/icon-quests-6.f5fa8003aa846105d1f32c05b50eab2d.svg";
export { ForwardRef as ReactComponent };